import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";
import decisionsCert from "../images/RFDecisionsDeveloperCert722.pdf";

export default class About extends Component {
  render() {
    return (
      <div>
        <ul className="mediaIconList">
          <li>
            <a
              href="https://github.com/rossfletcher19"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
          </li>
          <li>
            <a
              href="https://gitlab.com/fletchlives"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faGitlab} />
            </a>
          </li>
        </ul>
        <div className="About">
          <h5> A little about me.</h5>
          <p>
            I’m based in the beautiful Denver, Colorado area. I graduated from
            Oregon State University in 2009 with a Bachelor of Science degree in
            Business Administration. After college I spent around 8 years
            working in business operations, and in late 2017 I enrolled in a
            coding bootcamp and never looked back. I recently moved to Colorado
            and I'm excited to be in a new tech community.
          </p>

          <p>
            Currently I'm a{" "}
            <a href={decisionsCert} rel="noopener noreferrer" target="_blank">
              Decisions Developer
            </a>{" "}
            and I engineer, build, and troubleshoot business automation
            workflows and processes with{" "}
            <a
              href="https://decisions.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              DECISIONS
            </a>{" "}
            AI orchestration and process automation platform. In my free time if
            I'm dabbling with tech, I'm learning the AWS Cloud Ecosystem,
            building projects with Node.js, React.js, and ReactNative. I like
            building things that automate business processes and workflows.
          </p>

          <p>
            If you’d like to talk tech or have any questions about what I do or
            my journey to get here, I’d love to hear from you. Use the Contact
            page and I’d be happy to get back to you.
          </p>
        </div>
      </div>
    );
  }
}
